var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStarOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "m9.265 14.326-.268-.17-.267.17-4.976 3.158v-.001l1.328-5.986.063-.283-.214-.195L.508 6.998l-.003-.003a.033.033 0 0 1-.003-.003V6.99L.5 6.989a.037.037 0 0 1 .002-.02l5.814-.518.304-.027.115-.284L8.998.544l2.261 5.596.115.284.304.027 5.82.518v.002a.043.043 0 0 1 .001.021.015.015 0 0 1-.001.004L17.494 7l-4.42 4.019-.215.195.063.283 1.329 5.986v.001l-4.986-3.158Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarOutlined);
export default __webpack_public_path__ + "static/media/icon-star-outlined.1c8aa923.svg";
export { ForwardRef as ReactComponent };